export var CustomerType;
(function (CustomerType) {
    CustomerType[CustomerType["NotSet"] = 0] = "NotSet";
    CustomerType[CustomerType["Private"] = 1] = "Private";
    CustomerType[CustomerType["Business"] = 2] = "Business";
    CustomerType[CustomerType["SelfEmployed"] = 3] = "SelfEmployed";
})(CustomerType || (CustomerType = {}));
//# sourceMappingURL=ApplicationCustomer.js.map